module.exports = __webpack_public_path__ + "static/media/z.b75d98bd.svg";